import React from 'react';

export default function Pesame() {
  return (
    <>
            <p>
            Pésame Dios mío, <br /> me arrepiento de todo corazón de haberos ofendido, <br /> pésame por el infierno que merecí y por el cielo que perdí. <br /> Pero mucho más me pesa porque pecando ofendí a un Dios tan bueno y tan grande como Vos. <br/> Antes querría haber muerto que haberos ofendido; <br/> y propongo firmemente no pecar más <br/> y evitar las ocasiones próximas de pecado. <br/> Amén.
            </p>
    </>
  );
}
